import React, { useEffect } from "react";
import SlideRoutes from "react-slide-routes";
import { Route, Routes, useLocation } from "react-router-dom";

import { Top } from "./Pages/Top";
import { Lp } from "./Pages/Lp";
import { Consultant } from "./Pages/Consultant";
import { Column } from "./Pages/Column";
import { ColumnDetail } from "./Pages/ColumnDetail";
import { News } from "./Pages/News";
import { NewsDetail } from "./Pages/NewsDetail";
import { Privacy } from "./Pages/Privacy";
import { Company } from "./Pages/Company";
import { Contact } from "./Pages/Contact";

const App = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <Routes>
      <Route path="/" element={<Top />} />
      <Route path="/lp" element={<Lp />} />
      <Route path="/consultant" element={<Consultant />} />
      <Route path="/column" element={<Column />} />
      <Route path="/column/:id" element={<ColumnDetail />} />
      <Route path="/news" element={<News />} />
      <Route path="/news/:id" element={<NewsDetail />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/company" element={<Company />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
};

export default App;
